import BaseService from './BaseService';

class InfoBarService extends BaseService {
  /**
   * Fetch Snippets
   * @return {Promise}
   */
  fetchSnippets = () => {
    const config = {
      url: '/infobar/snippets',
    };
    return this.doRequest(config);
  };

  getSupportingData = () => {
    const config = {
      url: '/infobar',
    };
    return this.doRequest(config);
  };
}

export { InfoBarService as default };
